import { useState } from 'react';
import { Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/button';
import { RemoveDialog } from 'src/containers/Escrow/Remove';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { SoftwareEscrowsDocument } from 'src/graphql/actions/softwareEscrow/softwareEscrows.query';
import { apolloClient as client } from 'src/graphql';

const refetchEscrows = () => {
  client.cache.evict({ fieldName: 'softwareEscrows' });
  client.cache.gc();
  client.refetchQueries({
    include: [SoftwareEscrowsDocument],
  });
};

const RemoveAction = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const {
    softwareEscrow: { id },
  } = useSoftwareEscrow();

  const onClose = () => setIsOpen(false);

  const onOpen = () => setIsOpen(true);

  const onSuccess = () => {
    refetchEscrows();
    navigate('/software-escrows');
  };

  return (
    <RemoveDialog
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      successCallback={onSuccess}
      escrowId={id}
      triggerNode={
        <Button variant="destructive">
          <Trash2 /> Delete escrow
        </Button>
      }
    />
  );
};

export default RemoveAction;
